import { Component, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'

import { ListItem, QualityControlPipe, RepositoryModal } from '../../../shared'
import { PipeComponent } from './pipe.component'

@Component({
    templateUrl: './pipe-modal.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule],
})
export class PipeModalComponent extends RepositoryModal<QualityControlPipe> implements OnInit {
    vendorOptions: ListItem<number | null>[] = []
    trenchZoneVendorOptions: ListItem<number | null>[] = []

    ngOnInit() {
        const parentComponent = this.editOptions.initializeParams as PipeComponent

        // Build vendor options (all vendors), sorted alphabetically by name
        const allVendorsSorted = [...parentComponent.allVendors].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        this.vendorOptions = []
        this.vendorOptions.push(new ListItem<number | null>(null, 'Select a Vendor'))
        allVendorsSorted.forEach(x => {
            this.vendorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        // Build trench zone vendor options (dirt/aggregate vendors), sorted alphabetically by name
        const aggregateVendorsSorted = [...parentComponent.aggregateVendors].sort((a, b) => (a.name || '').localeCompare(b.name || ''))
        this.trenchZoneVendorOptions = []
        this.trenchZoneVendorOptions.push(new ListItem<number | null>(null, 'Select a Trench Zone Vendor'))
        aggregateVendorsSorted.forEach(x => {
            this.trenchZoneVendorOptions.push(new ListItem<number | null>(x.id, x.name))
        })

        if (this.isAdding) {
            // Set default job from parent
            this.target.job = parentComponent.selectedJob()
        }
    }

    protected onBeforeSave(): boolean {
        if (!this.target.job) {
            this.services.notification.warning('Job is required')
            return false
        }
        return true
    }
}
